export const CTA_WEBAPP = 'http://app.idagio.com/join';
export const CTA_APP_STORE = 'https://itunes.apple.com/app/idagio/id1014917700?mt=8';
export const CTA_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.idagio.app';
export const CTA_DESKTOP = 'https://app.idagio.com/download-desktop-app';
export const FACEBOOK_APP_ID = '642978282525451';
export const CAPTCHA_ACTION_SIGN_UP = 'signup';
export const ERROR_CAPTCHA_TOKEN = 'CLIENT_ERROR';
export const GIFT_CARD_PATH = 'promotions/gift-card';
export const DEFAULT_TRIAL_DURATION_IN_MONTHS = 2;
export const DEFAULT_PARTNER_VIDEO_ID_EN = 'SuKsdEYeZI8';
export const DEFAULT_PARTNER_VIDEO_ID_DE = 'rv5TaDaFxIo';
export const COOKIE_PREFERENCES_COOKIE = 'cookie-preferences';
export const BANNER_COOKIE = 'banner';
export const AB_COOKIE = 'idagio-ab';
export const COUNTRY_CODE_COOKIE = 'country-code';

export const PLAN_ID_PREMIUM = 'p-1m';
export const PLAN_ID_PP_1M = 'pp-1m';
export const PLAN_ID_PP_12M = 'pp-12m';
export const PLAN_ID_PPC_1M = 'ppc-1m';
export const PLAN_ID_PPC_12M = 'ppc-12m';

export const DEFAULT_PLAN_ID = PLAN_ID_PP_12M;

export const SUBSCRIPTION_PLANS = {
  [PLAN_ID_PREMIUM]: {
    months: 1,
    totalPrice: 9.99,
    monthlyPrice: 9.99,
  },
  [PLAN_ID_PP_1M]: {
    months: 1,
    totalPrice: 12.99,
    monthlyPrice: 12.99,
  },
  [PLAN_ID_PP_12M]: {
    months: 12,
    totalPrice: 119.88,
    monthlyPrice: 9.99,
  },
  [PLAN_ID_PPC_1M]: {
    months: 1,
    totalPrice: 29.99,
    monthlyPrice: 29.99,
  },
  [PLAN_ID_PPC_12M]: {
    months: 12,
    totalPrice: 199.99,
    monthlyPrice: 16.67,
  },
};
export const SMART_BANNER_WHITELIST_PATHS = ['/', 'concerts', 'idagio-interactive', 'magazine'];

export const BLACK_FRIDAY_EXPERIMENT = {
  id: 'black-friday-experiment',
  name: 'Landing Pages - Black Friday Banner',
  variant: {
    2024: '2024',
    2025: '2025',
  },
  defaultVariant: '2024',
};

export const BLACK_FRIDAY_PATH = 'black-friday';
export const BLACK_FRIDAY_PATH_2025 = 'black-friday';
export const BLACK_FRIDAY_START_DATE = new Date(Date.UTC(2026, 10, 1, 0, 0, 0));
export const BLACK_FRIDAY_END_DATE = new Date(Date.UTC(2026, 10, 30, 23, 59, 59));

export const VALENTINE_EXPERIMENT = {
  id: 'valentine-experiment-2026',
  name: 'Landing Pages - Valentine Banner 2026',
  variant: {
    giftCard: 'giftCard',
    discount: 'discount',
  },
  defaultVariant: 'giftCard',
};

export const VALENTINE_GIFT_CARD_PATH = 'valentine-gift';
export const VALENTINE_DISCOUNT_PATH = 'valentine-offer';
export const VALENTINE_START_DATE = new Date(Date.UTC(2026, 1, 10, 7, 0, 0));
export const VALENTINE_END_DATE = new Date(Date.UTC(2026, 2, 1, 7, 0, 0));

export const EASTER_PATH = 'easter';
export const MOTHERS_DAY_PATH = 'mothers-day';
export const WELCOME_GIFT_PATH = 'welcome-gift';

export const SPRING_SALE_PATH = 'spring-sale';
export const SPRING_SALE_START_DATE = new Date(Date.UTC(2026, 2, 1, 7, 0, 1));
export const SPRING_SALE_END_DATE = new Date(Date.UTC(2026, 4, 1, 7, 0, 0));

export const PROMOTION_PATH = 'promotions';



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/constants.js